export const RDX_MODULES = {
    ASSETS: "assets",
    GENERAL: "general",
    TEMPLATE_DATA: "template_data",
}

export const GENERAL_API_CALLS = {
    WEBSITE_DATA: "websites_data",
}
